"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Template = void 0;
var PublicKeyAccount_1 = require("../../account/PublicKeyAccount");
var AppCrypt_1 = require("../../../../crypt/AppCrypt");
var Base58_1 = require("../../../../crypt/libs/Base58");
var ItemCls_1 = require("../ItemCls");
var Bytes_1 = require("../../Bytes");
var BlockChain_1 = require("../../BlockChain");
var Transaction_1 = require("../../transaction/Transaction");
var DataWriter_1 = require("../../DataWriter");
var base64_1 = require("../../util/base64");
var Template = /** @class */ (function (_super) {
    __extends(Template, _super);
    function Template(owner, name, icon, image, description) {
        return _super.call(this, new Int8Array([1, 0]), owner, name, icon, image, description) || this;
    }
    /* tslint:disable-next-line */
    Template.parse = function (rowData, includeReference) {
        if (includeReference === void 0) { includeReference = false; }
        return __awaiter(this, void 0, void 0, function () {
            var data, typeBytes, position, ownerBytes, owner, fullNameLength, fullNameBytes, fullName, iconLengthBytes, iconLength, icon, imageLengthBytes, imageLength, image, descriptionLengthBytes, descriptionLength, descriptionBytes, description, reference, ownerSignature, template;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!base64_1.default.isBase64(rowData)) return [3 /*break*/, 1];
                        data = base64_1.default.decodeToByteArray(rowData);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, Base58_1.Base58.decode(rowData)];
                    case 2:
                        data = _a.sent();
                        _a.label = 3;
                    case 3:
                        typeBytes = data.slice(0, ItemCls_1.ItemCls.TYPE_LENGTH);
                        position = ItemCls_1.ItemCls.TYPE_LENGTH;
                        ownerBytes = data.slice(position, position + ItemCls_1.ItemCls.OWNER_LENGTH);
                        owner = new PublicKeyAccount_1.PublicKeyAccount(ownerBytes);
                        position += ItemCls_1.ItemCls.OWNER_LENGTH;
                        fullNameLength = data[position];
                        position++;
                        if (fullNameLength < 0) {
                            fullNameLength = 256 + fullNameLength;
                        }
                        if (fullNameLength < 1 || fullNameLength > ItemCls_1.ItemCls.MAX_NAME_LENGTH) {
                            throw new Error("Invalid full name length: " + fullNameLength);
                        }
                        fullNameBytes = data.slice(position, position + fullNameLength);
                        return [4 /*yield*/, Bytes_1.Bytes.stringFromByteArray(fullNameBytes)];
                    case 4:
                        fullName = _a.sent();
                        position += fullNameLength;
                        iconLengthBytes = data.slice(position, position + ItemCls_1.ItemCls.ICON_SIZE_LENGTH);
                        return [4 /*yield*/, Bytes_1.Bytes.intFromByteArray(new Int8Array([0, 0, iconLengthBytes[0], iconLengthBytes[1]]))];
                    case 5:
                        iconLength = _a.sent();
                        position += ItemCls_1.ItemCls.ICON_SIZE_LENGTH;
                        if (iconLength < 0 || iconLength > ItemCls_1.ItemCls.MAX_ICON_LENGTH) {
                            throw new Error('Invalid icon length: ' + iconLength);
                        }
                        icon = data.slice(position, position + iconLength);
                        position += iconLength;
                        imageLengthBytes = data.slice(position, position + ItemCls_1.ItemCls.IMAGE_SIZE_LENGTH);
                        return [4 /*yield*/, Bytes_1.Bytes.intFromByteArray(imageLengthBytes)];
                    case 6:
                        imageLength = _a.sent();
                        position += ItemCls_1.ItemCls.IMAGE_SIZE_LENGTH;
                        //if (imageLength < 0 || imageLength > ItemCls.MAX_IMAGE_LENGTH) {
                        if (imageLength < 0) {
                            throw new Error('Invalid image length: ' + imageLength);
                        }
                        image = data.slice(position, position + imageLength);
                        position += imageLength;
                        descriptionLengthBytes = data.slice(position, position + ItemCls_1.ItemCls.DESCRIPTION_SIZE_LENGTH);
                        return [4 /*yield*/, Bytes_1.Bytes.intFromByteArray(descriptionLengthBytes)];
                    case 7:
                        descriptionLength = _a.sent();
                        position += ItemCls_1.ItemCls.DESCRIPTION_SIZE_LENGTH;
                        if (descriptionLength < 0 || descriptionLength > BlockChain_1.BlockChain.MAX_REC_DATA_BYTES) {
                            throw new Error("Invalid description length: " + descriptionLength);
                        }
                        descriptionBytes = data.slice(position, position + descriptionLength);
                        return [4 /*yield*/, Bytes_1.Bytes.stringFromByteArray(descriptionBytes)];
                    case 8:
                        description = _a.sent();
                        position += descriptionLength;
                        reference = null;
                        if (includeReference) {
                            //READ REFERENCE
                            reference = data.slice(position, position + ItemCls_1.ItemCls.REFERENCE_LENGTH);
                            position += ItemCls_1.ItemCls.REFERENCE_LENGTH;
                        }
                        ownerSignature = null;
                        if (typeBytes[1] === 1) {
                            // with signature
                            //READ SIGNATURE
                            ownerSignature = data.slice(position, position + Transaction_1.Transaction.SIGNATURE_LENGTH);
                            // position += Transaction.SIGNATURE_LENGTH;
                        }
                        template = new Template(owner, fullName, icon, image, description);
                        template.typeBytes = typeBytes;
                        if (includeReference && reference) {
                            template.reference = reference;
                        }
                        if (ownerSignature) {
                            template.ownerSignature = ownerSignature;
                        }
                        return [2 /*return*/, template];
                }
            });
        });
    };
    Template.prototype.sign = function (secretKey) {
        return __awaiter(this, void 0, void 0, function () {
            var data, sign;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toBytes(false, true)];
                    case 1:
                        data = _a.sent();
                        sign = AppCrypt_1.AppCrypt.sign(data, secretKey);
                        this.ownerSignature = new Int8Array(sign);
                        return [2 /*return*/];
                }
            });
        });
    };
    Template.prototype.toBytes = function (includeReference, onlyBody) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        _b = (_a = data).set;
                        return [4 /*yield*/, _super.prototype.toBytes.call(this, includeReference, onlyBody)];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        if (!onlyBody && this.ownerSignature) {
                            data.set(this.ownerSignature);
                        }
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    return Template;
}(ItemCls_1.ItemCls));
exports.Template = Template;
